// src/app/services/environment.service.ts
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  
  get isDesignMode(): boolean {
    return environment.designMode;
  }
}